import LogoTitle from '../../assets/images/logo-s.png';
import { Link } from 'react-router-dom';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState} from 'react';
import Logo from './Logo';
import Loader from 'react-loaders';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    // const nameArray = [ 'o', 'u', 'm', 'y', 'a', 'd', 'e', 'v'];
    // const jobArray = ['A', ' ', 'S', 'o', 'f', 't', 'w', 'a', 'r', 'e', ' ', 'D', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r'];
    setTimeout(() => {
        setLetterClass('text-animate-hover');
    }, 4000);

    document.title = "Portfolio | Home";

    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters letterClass={letterClass} myStr={"Hello"} flag={0} /> 🖐️,
                    <br />
                    <AnimatedLetters letterClass={letterClass} myStr={"I'm"} flag={3} />
                    <img src={LogoTitle} alt="S" />
                    <AnimatedLetters letterClass={letterClass} myStr={"oumyadev"} flag={5} />, 
                    <br />
                    <AnimatedLetters letterClass={letterClass} myStr={"A"} flag={8}/>{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Software"} flag={8}/>{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Developer"} flag={10}/> .
                </h1>
                <h2>App Development / Web Development / Blockchain Development </h2>
                <Link to = "/contact" className="flat-button">CONTACT ME</Link>
            </div>
            <Logo />
        </div>
        <Loader type="ball-spin-fade-loader" />
        </>
    );
}
export default Home;